export const YotpoIcon = () => {
  return (
    <img
      width="32"
      height="32"
      src="/assets/logo-yotpo.png"
      alt="Yotpo | Customer reviews, visual marketing, loyalty, referrals, and SMS marketing"
    />
  );
};
